import { Factory, trait } from 'miragejs';
import { getUnixTime, addHours, addMinutes } from 'date-fns';

export default Factory.extend({
  available: true,
  maxOccupancy: 30,
  peopleRegistered: () => Math.round(Math.random() * 29),
  hasRequiredDocumentApproval: true,

  asUnavailable: trait({
    available: false,
  }),
  asFull: trait({
    maxOccupancy: 30,
    peopleRegistered: 30,
  }),
  withInvite: trait({
    afterCreate(registrationDate, server) {
      const screeningCardable = server.create('graphql/invite', { expectedArrivalTime: registrationDate.date });
      server.create('invite', { ...screeningCardable.attrs, locationId: 1 });
      registrationDate.update({ screeningCardable });
    },
  }),
  withRegisteredInvite: trait({
    afterCreate(registrationDate, server) {
      const screeningCardable = server.create('graphql/invite', 'asRegistered', {
        expectedArrivalTime: registrationDate.date,
      });
      registrationDate.update({ screeningCardable });
    },
  }),
  withDeniedInvite: trait({
    afterCreate(registrationDate, server) {
      const screeningCardable = server.create('graphql/invite', 'asDenied', {
        expectedArrivalTime: registrationDate.date,
      });
      registrationDate.update({ screeningCardable });
    },
  }),
  withSelfCertify: trait({
    afterCreate(registrationDate, server) {
      const screeningCardable = server.create('graphql/self-certify', {
        expectedArrivalTime: registrationDate.date,
      });
      registrationDate.update({ screeningCardable });
    },
  }),

  withEntryNoDeskReservation: trait({
    afterCreate(registrationDate, server) {
      const entry = server.create('graphql/entry', { signedInAt: addMinutes(registrationDate.date, 5) });
      const screeningCardable = server.create('graphql/invite', 'asRegistered', {
        entry,
        expectedArrivalTime: registrationDate.date,
      });
      registrationDate.update({ screeningCardable, entry });
    },
  }),

  withDeskReservation: trait({
    afterCreate(registrationDate, server) {
      const expectedArrivalTime = registrationDate.date;
      const screeningCardable = server.create('graphql/invite', { expectedArrivalTime });
      server.create('invite', { ...screeningCardable.attrs, locationId: 1 });
      const reservation = server.create('graphql/reservation', {
        inviteId: screeningCardable.id,
        startTime: getUnixTime(expectedArrivalTime),
        endTime: getUnixTime(addHours(expectedArrivalTime, 8)),
      });
      registrationDate.update({ screeningCardable, reservation });
    },
  }),

  withEntryAndDeskReservation: trait({
    afterCreate(registrationDate, server) {
      const expectedArrivalTime = registrationDate.date;
      const entry = server.create('graphql/entry', { signedInAt: expectedArrivalTime });
      const screeningCardable = server.create('graphql/invite', 'asRegistered', {
        entry,
        expectedArrivalTime,
      });
      const reservation = server.create('graphql/reservation', {
        inviteId: screeningCardable.id,
        startTime: getUnixTime(expectedArrivalTime),
        endTime: getUnixTime(addMinutes(expectedArrivalTime, 240)),
      });
      registrationDate.update({ screeningCardable, entry, reservation });
    },
  }),

  withEmployeeRegistration: trait({
    afterCreate(company, server) {
      server.create('company-role', { company }, 'withUser', 'asGlobalAdmin');
    },
  }),
});
